(function () {
	const METHOD = "/api/method/aracwebshop.aracwebshop.address_suggestions.get_address_suggestions";
	const ADDRESS_FIELDS = {
		address_line1: "address_line1",
		address_line2: "address_line2",
		city: "city",
		state: "state",
		country: "country",
		pincode: "pincode",
	};
	const PROVIDER_FIELDS = {
		custom_address_provider: "provider",
		custom_provider_place_id: "place_id",
		custom_address_provider_formatted: "formatted",
		custom_address_provider_confidence: "confidence",
		custom_latitude: "latitude",
		custom_longitude: "longitude",
	};

	let styleAdded = false;
	let selectedVerificationToken = "";
	let webFormPatched = false;

	function isAddressWebForm() {
		const path = window.location.pathname || "";
		return path.indexOf("/address") === 0
			|| document.documentElement.classList.contains("address-web-form-page")
			|| Boolean(window.frappe && frappe.web_form_doc && frappe.web_form_doc.doc_type === "Address");
	}

	function __(text) {
		return window.__ ? window.__(text) : text;
	}

	function addStyles() {
		if (styleAdded) return;
		styleAdded = true;
		const style = document.createElement("style");
		style.textContent = `
			.arac-address-autocomplete-control {
				margin-bottom: 0.75rem !important;
				position: relative;
				z-index: 1000;
				width: 100%;
			}

			html.address-web-form-page .web-form-container,
			html.address-web-form-page .web-form,
			html.address-web-form-page .web-form-body,
			html.address-web-form-page .web-form-wrapper,
			html.address-web-form-page .form-layout,
			html.address-web-form-page .form-page,
			html.address-web-form-page .form-section,
			html.address-web-form-page .section-body,
			html.address-web-form-page .form-column,
			html.address-web-form-page .form-column > form,
			html.address-web-form-page .frappe-control[data-fieldname="address_line1"] {
				overflow: visible !important;
			}

			html.address-web-form-page .frappe-control[data-fieldname="address_line1"] {
				position: relative;
				z-index: 1000;
			}

			.arac-address-autocomplete-control .control-label {
				color: inherit;
				display: block;
				font-size: 0.75rem;
				font-weight: 900;
				letter-spacing: 0;
				margin-bottom: 0.45rem;
				text-transform: uppercase;
			}

			.arac-address-autocomplete {
				position: relative;
				width: 100%;
			}

			.arac-address-suggestions {
				background: var(--card-bg, #ffffff);
				border: 1px solid var(--border-color, #dbe4ef);
				border-radius: 0.9rem;
				box-shadow: 0 20px 45px rgba(15, 23, 42, 0.16);
				left: 0;
				margin-top: 0.35rem;
				max-height: 18rem;
				overflow-y: auto;
				position: absolute;
				right: 0;
				top: 100%;
				z-index: 2147483000;
			}

			.arac-address-suggestions[hidden] {
				display: none;
			}

			.arac-address-suggestion {
				background: transparent;
				border: 0;
				border-bottom: 1px solid var(--border-color, #dbe4ef);
				color: var(--text-color, #0f172a);
				cursor: pointer;
				display: block;
				padding: 0.85rem 1rem;
				text-align: start;
				width: 100%;
			}

			.arac-address-suggestion:last-child {
				border-bottom: 0;
			}

			.arac-address-suggestion:hover,
			.arac-address-suggestion:focus {
				background: color-mix(in srgb, var(--theme-primary, #449CF0) 14%, transparent);
				outline: none;
			}

			.arac-address-suggestion-primary {
				display: block;
				font-size: 0.92rem;
				font-weight: 800;
				line-height: 1.35;
			}

			.arac-address-suggestion-secondary,
			.arac-address-status {
				color: var(--text-muted, #64748b);
				display: block;
				font-size: 0.8rem;
				font-weight: 650;
				line-height: 1.35;
				margin-top: 0.25rem;
			}

			.arac-address-status.is-valid {
				color: #16a34a;
			}

			.arac-address-status.is-error {
				color: #dc2626;
			}
		`;
		document.head.appendChild(style);
	}

	function getAddressLine1Control() {
		return document.querySelector(".web-form .frappe-control[data-fieldname='address_line1']")
			|| document.querySelector(".frappe-control[data-fieldname='address_line1']");
	}

	function getWebForm() {
		return window.frappe && window.frappe.web_form;
	}

	function setWebFormValue(fieldname, value) {
		const webForm = getWebForm();
		const normalized = value == null ? "" : String(value);
		if (webForm && webForm.doc) {
			webForm.doc[fieldname] = normalized;
		}
		if (webForm && typeof webForm.set_value === "function" && webForm.fields_dict && webForm.fields_dict[fieldname]) {
			webForm.set_value(fieldname, normalized);
			return;
		}
		const input = document.querySelector(`.frappe-control[data-fieldname="${fieldname}"] input, .frappe-control[data-fieldname="${fieldname}"] textarea, .frappe-control[data-fieldname="${fieldname}"] select`);
		if (input) {
			input.value = normalized;
			input.dispatchEvent(new Event("input", { bubbles: true }));
			input.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}

	function injectControl() {
		if (!isAddressWebForm() || document.querySelector(".arac-address-autocomplete-control")) return false;
		const line1Control = getAddressLine1Control();
		if (!line1Control) return false;

		document.documentElement.classList.add("address-web-form-page");
		addStyles();
		patchWebFormSaveHandler();
		const control = document.createElement("div");
		control.className = "arac-address-autocomplete-control";
		control.innerHTML = `
			<label class="control-label" for="arac-address-search">${__("Search Address")}</label>
			<div class="arac-address-autocomplete">
				<input id="arac-address-search" class="form-control" type="text" autocomplete="off" placeholder="${__("Start typing the address")}">
				<div class="arac-address-suggestions" role="listbox" hidden></div>
			</div>
			<div class="arac-address-status" aria-live="polite"></div>
		`;
		line1Control.prepend(control);
		bindControl(control);
		return true;
	}

	function bindControl(control) {
		const input = control.querySelector("#arac-address-search");
		const suggestionsEl = control.querySelector(".arac-address-suggestions");
		const status = control.querySelector(".arac-address-status");
		let timer = null;
		let abortController = null;

		function setStatus(message, state) {
			status.textContent = message || "";
			status.classList.toggle("is-valid", state === "valid");
			status.classList.toggle("is-error", state === "error");
		}

		function hideSuggestions() {
			suggestionsEl.hidden = true;
			input.setAttribute("aria-expanded", "false");
		}

		function showSuggestions() {
			if (!suggestionsEl.children.length) return;
			suggestionsEl.hidden = false;
			input.setAttribute("aria-expanded", "true");
		}

		function selectSuggestion(suggestion) {
			input.value = suggestion.formatted || "";
			selectedVerificationToken = suggestion.verification_token || "";
			for (const [fieldname, key] of Object.entries(ADDRESS_FIELDS)) {
				setWebFormValue(fieldname, suggestion[key]);
			}
			for (const [fieldname, key] of Object.entries(PROVIDER_FIELDS)) {
				setWebFormValue(fieldname, suggestion[key]);
			}
			setStatus(__("Address fields filled from Geoapify."), "valid");
			hideSuggestions();
			if (window.frappe) {
				window.frappe.form_dirty = true;
			}
		}

		function renderSuggestions(suggestions) {
			suggestionsEl.replaceChildren();
			if (!suggestions.length) {
				hideSuggestions();
				setStatus(__("No matching addresses found."), "error");
				return;
			}

			suggestions.forEach((suggestion) => {
				const button = document.createElement("button");
				button.type = "button";
				button.className = "arac-address-suggestion";
				button.setAttribute("role", "option");
				const secondary = [suggestion.city, suggestion.state, suggestion.pincode, suggestion.country]
					.filter(Boolean)
					.join(", ");
				button.innerHTML = `
					<span class="arac-address-suggestion-primary"></span>
					<span class="arac-address-suggestion-secondary"></span>
				`;
				button.querySelector(".arac-address-suggestion-primary").textContent = suggestion.address_line1 || suggestion.formatted || "";
				button.querySelector(".arac-address-suggestion-secondary").textContent = secondary;
				button.addEventListener("click", () => selectSuggestion(suggestion));
				suggestionsEl.appendChild(button);
			});
			setStatus("", "");
			showSuggestions();
		}

		function search(query) {
			if (abortController) abortController.abort();
			abortController = new AbortController();
			setStatus(__("Searching Geoapify..."), "");

			const params = new URLSearchParams({ text: query, limit: "6" });
			fetch(`${METHOD}?${params.toString()}`, { signal: abortController.signal })
				.then((response) => response.json())
				.then((data) => {
					const payload = data.message || {};
					if (!payload.enabled) {
						hideSuggestions();
						setStatus(__("Geoapify address suggestions are not configured."), "error");
						return;
					}
					renderSuggestions(payload.suggestions || []);
				})
				.catch((error) => {
					if (error.name === "AbortError") return;
					hideSuggestions();
					setStatus(__("Geoapify suggestions are unavailable."), "error");
				});
		}

		input.addEventListener("input", () => {
			window.clearTimeout(timer);
			const query = input.value.trim();
			if (query.length < 3) {
				hideSuggestions();
				setStatus("", "");
				return;
			}
			timer = window.setTimeout(() => search(query), 250);
		});
		input.addEventListener("focus", showSuggestions);
		input.addEventListener("blur", () => window.setTimeout(hideSuggestions, 160));
	}

	function patchWebFormSaveHandler() {
		const webForm = getWebForm();
		if (!webForm || webFormPatched || typeof webForm.handle_success !== "function") return;

		webFormPatched = true;
		const originalHandleSuccess = webForm.handle_success.bind(webForm);
		webForm.handle_success = function (data) {
			const addressName = data && data.name ? data.name : (webForm.doc && webForm.doc.name);
			if (selectedVerificationToken && addressName && window.frappe && typeof window.frappe.call === "function") {
				window.frappe.call({
					type: "POST",
					method: "aracwebshop.aracwebshop.address_suggestions.update_address_provider_metadata",
					args: {
						address_name: addressName,
						verification_token: selectedVerificationToken,
					},
				});
			}
			return originalHandleSuccess(data);
		};
	}

	function setup() {
		if (injectControl()) return;
		const root = document.querySelector(".web-form-wrapper") || document.querySelector(".web-form-body") || document.body;
		const observer = new MutationObserver(() => {
			if (injectControl()) observer.disconnect();
		});
		observer.observe(root, { childList: true, subtree: true });
		window.setTimeout(injectControl, 800);
		window.setTimeout(injectControl, 2000);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", setup);
	} else {
		setup();
	}
})();
